import { useMutation } from "@tanstack/react-query";
import { api, type models } from "jiffy-api";
import { objNamesToCamelCase } from "common/utils/helpers/cases";

export function useCanvaSelectDesign() {
  return useMutation({
    mutationFn: (params: models.canva.selectDesign.Request) =>
      api.canva.selectDesign(params).then(objNamesToCamelCase)
  });
}
